/* Every carousel in the theme, in one place.

   Markup:
     <div data-carousel-scope>                      optional: where the arrows live
       <div class="swiper" data-carousel='{"slidesPerView":2.1}'>
         <div class="swiper-wrapper">
           <div class="swiper-slide">…</div>

   The data-carousel attribute holds plain Swiper options, so a section only
   declares what it needs. Arrows are any [data-prev] / [data-next] element
   inside the scope. */
window.BronsonCarousel = {
  init(el) {
    if (!el || !window.Swiper || el.swiper) return;

    let options = {};
    try {
      options = JSON.parse(el.dataset.carousel || '{}');
    } catch (err) {}

    const scope = el.closest('[data-carousel-scope]') || el.parentElement || el;
    const prevEl = scope.querySelector('[data-prev]');
    const nextEl = scope.querySelector('[data-next]');

    const swiper = new Swiper(el, {
      navigation: prevEl || nextEl ? { prevEl, nextEl } : false,
      ...options,
    });

    el.dispatchEvent(new CustomEvent('carousel:ready', { detail: swiper, bubbles: true }));
  },

  refresh(el) {
    if (el && el.swiper) el.swiper.destroy(true, true);
    this.init(el);
  },

  initAll(root) {
    (root || document).querySelectorAll('[data-carousel]').forEach((el) => this.init(el));
  },
};

document.addEventListener('DOMContentLoaded', () => window.BronsonCarousel.initAll());
document.addEventListener('shopify:section:load', (e) => window.BronsonCarousel.initAll(e.target));
